import { Badge } from '@elkaso-app/web-design';
import React from 'react';

const statusStyles: Record<string, { color: string; bgColor: string; label: string }> = {
  NOT_UPLOADED: { color: '#718096', bgColor: 'rgba(113, 128, 150, 0.08)', label: 'Not Uploaded' },
  PENDING_OCR: { color: '#D69E2E', bgColor: 'rgba(214, 158, 46, 0.08)', label: 'Pending OCR' },
  VALID: { color: '#38A169', bgColor: 'rgba(56, 161, 105, 0.08)', label: 'Valid' },
  EXPIRED: { color: '#E53E3E', bgColor: 'rgba(229, 62, 62, 0.08)', label: 'Expired' },
};

interface DocumentStatusBadgeProps {
  status: string;
}

export const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = ({ status }) => {
  const style = statusStyles[status] ?? statusStyles.NOT_UPLOADED;

  return (
    <Badge
      color={style.color}
      bgColor={style.bgColor}
      px='md'
      py='sm'
      borderRadius='full'
      fontSize='xs'
      _hover={{ shadow: 'sm' }}>
      {style.label}
    </Badge>
  );
};
